<div class="dialog-wrapper">
    <h1>{{ data.title }}</h1>
    <button mat-icon-button (click)="onNoClick()" class="close">
        <mat-icon>close</mat-icon>
    </button>

    <div class="dialog-content">
        <ng-template #voicesection>
            <ng-container *ngIf="!voiceActiveSectionError; else failure">
                <ng-container *ngIf="!voiceText">
                    <p class="voice-text">{{ 'We are listening...' | translate }}</p>
                </ng-container>
                <ng-container *ngIf="voiceText">
                    <p class="voice-text">{{ voiceText }}</p>
                    <div class="use-this">
                        <button mat-flat-button color="primary" [mat-dialog-close]="voiceText">
                            <mat-icon>done</mat-icon>{{ 'Grab this text' | translate }}
                        </button>
                    </div>
                </ng-container>
            </ng-container>
        </ng-template>

        <ng-template #failure>
            <p class="voice-text">{{ "Didn't catch that" | translate }}</p>

        </ng-template>

        <div *ngIf="voiceActiveSectionDisabled; else voicesection;">
            <button type="button" (click)="startVoiceRecognition()">{{ 'Record' | translate }}</button>
        </div>

        <div class="mic" [ngClass]="{
                'stopped': !voiceActiveSectionListening,
                'listening': voiceActiveSectionListening
            }" (click)="onMicClick()">
            <div class="circle background" *ngIf="voiceActiveSectionListening"></div>
            <div class="gn">
                <div class="mc"></div>
            </div>
            <span class="txt" *ngIf="!voiceActiveSectionListening">
                {{ 'Tap the microphone to try again' | translate }}
            </span>
        </div>
    </div>
</div>